import { Skeleton, stylize } from "@envestnet/envreact-component-library";
import React from "react";
import withIntl from "utils/withIntl";
import styles, { Styles } from "./styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/pro-solid-svg-icons";

interface InjectedProps extends Styles {
  url: string;
  tileName: string;
}

interface DefaultProps {
  // Default props should always be required props, i.e. no ? indicating it's optional
  // The default values are specified below
  isLoading: boolean;
}

export interface TileProps extends DefaultProps {}

const defaultProps: DefaultProps = {
  isLoading: false,
};

type Props = InjectedProps & TileProps;

const Tile = (props: Props) => {
  const { classes, url, tileName, isLoading } = props;

  if (isLoading) {
    return (
      <Skeleton
        width="390px"
        height="64px"
        animation="wave"
        style={{ marginTop: "20px", marginRight: "20px" }}
      />
    );
  }

  return (
    <div
      role="link"
      className={classes.container}
      onClick={() => {
        window.open(url, "_blank", "noopener,noreferrer");
      }}
      tabIndex={0}
    >
      <div className={classes.content}>
        <span className={classes.tileHeader}>{tileName}</span>
        {/* <span className={classes.tileDescription}>This is a description</span> */}
      </div>
      <div className={classes.tileIcon}>
        <FontAwesomeIcon icon={faAngleRight} />
      </div>
    </div>
  );
};

Tile.defaultProps = defaultProps;

export default withIntl(stylize<Props, DefaultProps>(styles)(Tile));
